import { render, staticRenderFns } from "./SnackbarNotification2.vue?vue&type=template&id=6cbf5cb9&scoped=true&"
import script from "./SnackbarNotification2.vue?vue&type=script&lang=js&"
export * from "./SnackbarNotification2.vue?vue&type=script&lang=js&"
import style0 from "./SnackbarNotification2.vue?vue&type=style&index=0&id=6cbf5cb9&lang=scss&"
import style1 from "./SnackbarNotification2.vue?vue&type=style&index=1&id=6cbf5cb9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbf5cb9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cbf5cb9')) {
      api.createRecord('6cbf5cb9', component.options)
    } else {
      api.reload('6cbf5cb9', component.options)
    }
    module.hot.accept("./SnackbarNotification2.vue?vue&type=template&id=6cbf5cb9&scoped=true&", function () {
      api.rerender('6cbf5cb9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/core/SnackbarNotification/SnackbarNotification2.vue"
export default component.exports